const filterGallery = {
  showFilterGallery: false,
  filterEntityId: null,
  filterEntityName: null,
};

const metricStudio = {
  showEntityConfiguration: true,
};

export default function() {
  return {
    showVariableEditor: false,
    showNodeEditor: false,
    showInvitePopup: false,
    showCreateDashboardPopup: false,
    showDashboardSharePopup: false,
    showMetricCreationPopup: false,
    showVerifyEmailPopup: false,
    showWindowSelectionPopup: false,
    showComputedPropertyCreationPopup: false,
    showConsoleDetailsPopup: false,
    showGridLookupPopup: false,
    ...metricStudio,
    ...filterGallery,
  };
}
